// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"631":"129ced1a","719":"cd9ec26f","848":"2b47940a","856":"cf414569","967":"50307caa"}[chunkId] + ".chunk.js";
};